import {CoverType, getCoverTypes} from '../../const';

export type CoverTypeSelectionValue = CoverType | null;

export const CoverTypeSelectionValueOptions = getCoverTypes();
